// extracted by mini-css-extract-plugin
export var videoResponsive = "youTubeEmbed-module--videoResponsive--9H8-6";